/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as planV1 from "./keyapis_subscription_plan_v1.pb"

/**
 * Сервис реализует функционал управления коммерческими возможностями(КВ).
 * КВ это описание доступных технологических планов(ТП) на ОРПОНе(на доме)
 */

/**
 * Сервис коммерческих возможностей(КВ)
 */
export class OfferServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения коммерческой возможности.
   * Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)
   */
  GetOffer = (req: GetOfferRequestDto, init?: RequestInit): Promise<GetOfferResponseDto> => {
    return fm.request<GetOfferRequestDto, GetOfferResponseDto>(`${this.host}/subscription/api/v1/offer/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка коммерческих возможностей.
   * Метод доступен для: admin, mrf, master, external_seller, ltp_first, owner, employee, service, application(subscription:read или subscription:edit)
   */
  GetOfferList = (req?: GetOfferListRequestDto, init?: RequestInit): Promise<GetOfferListResponseDto[]> => {
    return fm.list<GetOfferListRequestDto, GetOfferListResponseDto>(`${this.host}/subscription/api/v1/offer/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества коммерческих возможностей.
   * Метод доступен для: admin, mrf, master, external_seller, ltp_first, owner, employee, service, application(subscription:read или subscription:edit)
   */
  GetOfferCount = (req?: GetOfferCountRequestDto, init?: RequestInit): Promise<GetOfferCountResponseDto> => {
    return fm.request<GetOfferCountRequestDto, GetOfferCountResponseDto>(`${this.host}/subscription/api/v1/offer/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник условий на скидки
 */
export enum OfferDiscountRequirementType {
  /**
   * Значение не указано.
   * Если указана цена по скидке, а условие не проставлено, скидка не отображается и не применяется
   */
  DISCOUNT_REQUIREMENT_TYPE_UNKNOWN = "DISCOUNT_REQUIREMENT_TYPE_UNKNOWN",
  /**
   * Безусловная скидка
   */
  NO_CONDITIONS = "NO_CONDITIONS",
  /**
   * ШПД интернет оплачен
   */
  INTERNET_IS_PAID = "INTERNET_IS_PAID",
}
/**
 * Справочник условий на скидки
 */
export type OfferDiscountRequirementTypeResponseEnum = keyof typeof OfferDiscountRequirementType
/**
 * Справочник условий на скидки
 */
export type OfferDiscountRequirementTypeRequestEnum = Exclude<OfferDiscountRequirementTypeResponseEnum, "DISCOUNT_REQUIREMENT_TYPE_UNKNOWN">;

/**
 * Типы статусов коммерческих возможностей
 */
export enum OfferStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Активно.
   * Доступно
   */
  ACTIVE = "ACTIVE",
  /**
   * Заблокировано.
   * Приостановлено
   */
  BLOCKED = "BLOCKED",
}
/**
 * Типы статусов коммерческих возможностей
 */
export type OfferStatusTypeResponseEnum = keyof typeof OfferStatusType
/**
 * Типы статусов коммерческих возможностей
 */
export type OfferStatusTypeRequestEnum = Exclude<OfferStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Типы коммерческих возможностей
 */
export enum OfferType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * УК.
   * Услуги, которые назначаются на управляющие компанию
   */
  COMPANY = "COMPANY",
  /**
   * Ростелеком.
   * Услуги, которые Ростелеком подключает напрямую физическим лицам
   */
  RTK = "RTK",
  /**
   * Общая.
   * Услуги, которые видят клиенты обоих типов
   */
  SHARED = "SHARED",
}
/**
 * Типы коммерческих возможностей
 */
export type OfferTypeResponseEnum = keyof typeof OfferType
/**
 * Типы коммерческих возможностей
 */
export type OfferTypeRequestEnum = Exclude<OfferTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum OfferPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type OfferPagingDirectionTypeResponseEnum = keyof typeof OfferPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type OfferPagingDirectionTypeRequestEnum = Exclude<OfferPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum OfferPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По цене
   */
  PRICE = "PRICE",
}
/**
 * Справочник типов значений сортировки
 */
export type OfferPagingOrderByTypeResponseEnum = keyof typeof OfferPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type OfferPagingOrderByTypeRequestEnum = Exclude<OfferPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества коммерческих возможностей
 */
export type GetOfferCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: OfferFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества коммерческих возможностей
 */
export type GetOfferCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего коммерческих возможностей
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetOfferCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества коммерческих возможностей
 */
export type GetOfferCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly offerFilterValidation: OfferFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества коммерческих возможностей
 */
export type GetOfferCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly offerFilterValidation: OfferFilterValidationErrorResponseDto
}>
/**
 * Запрос получения коммерческих возможностей
 */
export type GetOfferListRequestDto = {
  /**
   * Фильтр
   */
  filter?: OfferFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: OfferPagingRequestDto
}>
/**
 * Ответ на запрос получения коммерческих возможностей
 */
export type GetOfferListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Коммерческая возможность
   */
  readonly data: OfferResponseDto
  /**
   * Ошибка
   */
  readonly error: GetOfferListResponseErrorDto
}>
/**
 * Ошибка запроса получения коммерческих возможностей
 */
export type GetOfferListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly offerFilterValidation: OfferFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации по страницам
   */
  readonly offerPagingValidation: OfferPagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения коммерческих возможностей
 */
export type GetOfferListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly offerFilterValidation: OfferFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации по страницам
   */
  readonly offerPagingValidation: OfferPagingValidationErrorResponseDto
}>
/**
 * Запрос получения коммерческой возможности
 */
export type GetOfferRequestDto = {
  /**
   * Идентификатор коммерческой возможности
   */
  id: string
}
/**
 * Ответ на запрос получения коммерческой возможности
 */
export type GetOfferResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Коммерческая возможность
   */
  readonly data: OfferResponseDto
}>
/**
 * Коммерческая возможность(КВ)
 */
export type OfferRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Тип коммерческой возможности
   */
  type: OfferTypeRequestEnum
  /**
   * ОРПОН.
   * Идентификатор дома
   */
  orpon: string
  /**
   * Идентификатор компании
   */
  companyId?: number | null
  /**
   * Идентификатор технологического плана
   */
  planId: number
  /**
   * Подключать ли автоматическую подписку
   */
  isEnableAutoSubscribe?: boolean
  /**
   * Тип статуса заказа
   */
  statusType: OfferStatusTypeRequestEnum
  /**
   * Цена
   */
  price?: number | null
  /**
   * Признак принадлежности к цифровому пути
   */
  isDigitalWay?: boolean
  /**
   * Адрес размещения офферты.
   * Полный url до файла
   */
  offerUrl?: string | null
  /**
   * Снапшот состояния технологического плана на момент создания предложения.
   * В данный момент это ссылка в базе на запись, в будущем это будет снапшот
   */
  plan?: planV1.PlanRequestDto | null
  /**
   * Цена по скидке
   */
  discountPrice?: number | null
  /**
   * Условия на скидку.
   * Если условий много то для срабатывания должны выполнять все условия
   */
  discountRequirementTypes?: OfferDiscountRequirementTypeRequestEnum[]
}
/**
 * Коммерческая возможность(КВ)
 */
export type OfferResponseDto = {
  /**
   * Идентификатор
   */
  readonly id: number
  /**
   * Тип коммерческой возможности
   */
  type: OfferTypeResponseEnum
  /**
   * ОРПОН.
   * Идентификатор дома
   */
  orpon: string
  /**
   * Идентификатор компании
   */
  companyId: number | null
  /**
   * Идентификатор технологического плана
   */
  planId: number
  /**
   * Подключать ли автоматическую подписку
   */
  isEnableAutoSubscribe: boolean
  /**
   * Тип статуса заказа
   */
  statusType: OfferStatusTypeResponseEnum
  /**
   * Цена
   */
  price: number | null
  /**
   * Признак принадлежности к цифровому пути
   */
  isDigitalWay: boolean
  /**
   * Дата создания записи.
   * Заполняется сервером
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Адрес размещения офферты.
   * Полный url до файла
   */
  offerUrl: string | null
  /**
   * Снапшот состояния технологического плана на момент создания предложения.
   * В данный момент это ссылка в базе на запись, в будущем это будет снапшот
   */
  plan: planV1.PlanResponseDto | null
  /**
   * Цена по скидке
   */
  discountPrice: number | null
  /**
   * Условия на скидку.
   * Если условий много то для срабатывания должны выполнять все условия
   */
  discountRequirementTypes: OfferDiscountRequirementTypeResponseEnum[]
}
/**
 * Фильтр по коммерческим возможностям
 */
export type OfferFilterRequestDto = {
  /**
   * По типам
   */
  types?: OfferTypeResponseEnum[]
  /**
   * По ОРПОНам
   */
  orpons?: string[]
  /**
   * По идентификаторам компаний
   */
  companyIds?: number[]
}
/**
 * Фильтр по коммерческим возможностям
 */
export type OfferFilterResponseDto = {
  /**
   * По типам
   */
  types: OfferTypeResponseEnum[]
  /**
   * По ОРПОНам
   */
  orpons: string[]
  /**
   * По идентификаторам компаний
   */
  companyIds: number[]
}
/**
 * Ошибки валидации фильтра по коммерческим возможностям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type OfferFilterValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Формат ОРПОН некорректен
   */
  readonly orpons: OfferFilterValidationErrorOrponsInvalidRequestDto
  /**
   * Формат идентификатора компании некорректен
   */
  readonly companyIds: OfferFilterValidationErrorCompanyIdsInvalidRequestDto
}>
/**
 * Ошибки валидации фильтра по коммерческим возможностям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type OfferFilterValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Формат ОРПОН некорректен
   */
  readonly orpons: OfferFilterValidationErrorOrponsInvalidResponseDto
  /**
   * Формат идентификатора компании некорректен
   */
  readonly companyIds: OfferFilterValidationErrorCompanyIdsInvalidResponseDto
}>
/**
 * Причины:
 * - Формат идентификатора компании некорректен;
 * - Идентификатора компании передан некорректно, к примеру, значение <= 1
 */
export type OfferFilterValidationErrorCompanyIdsInvalidRequestDto = {
}
/**
 * Причины:
 * - Формат идентификатора компании некорректен;
 * - Идентификатора компании передан некорректно, к примеру, значение <= 1
 */
export type OfferFilterValidationErrorCompanyIdsInvalidResponseDto = {
}
/**
 * - Формат ОРПОН некорректен;
 * - ОРПОН передан некорректно, к примеру, значение <= 1
 */
export type OfferFilterValidationErrorOrponsInvalidRequestDto = {
}
/**
 * - Формат ОРПОН некорректен;
 * - ОРПОН передан некорректно, к примеру, значение <= 1
 */
export type OfferFilterValidationErrorOrponsInvalidResponseDto = {
}
/**
 * Пагинация по коммерческим возможностям
 */
export type OfferPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: OfferPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: OfferPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация по коммерческим возможностям
 */
export type OfferPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: OfferPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: OfferPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по коммерческим возможностям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type OfferPagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: OfferPagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: OfferPagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по коммерческим возможностям.
 * Эти проверки выполняются до обращения в базу данных
 */
export type OfferPagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: OfferPagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: OfferPagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type OfferPagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type OfferPagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type OfferPagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type OfferPagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества коммерческих возможностей
   */
  "GetOfferCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества коммерческих возможностей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "OfferFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества коммерческих возможностей
   */
  "GetOfferCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества коммерческих возможностей",
    "fields": {
      /**
       * Всего коммерческих возможностей
       */
      "data": {
        "type": "int32",
        "text": "Всего коммерческих возможностей",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetOfferCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества коммерческих возможностей
   */
  "GetOfferCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества коммерческих возможностей",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "offerFilterValidation": {
        "type": "OfferFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
    },
  },
  /**
   * Запрос получения коммерческих возможностей
   */
  "GetOfferListRequest": {
    "kind": "class",
    "text": "Запрос получения коммерческих возможностей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "OfferFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "OfferPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения коммерческих возможностей
   */
  "GetOfferListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения коммерческих возможностей",
    "fields": {
      /**
       * Коммерческая возможность
       */
      "data": {
        "type": "Offer",
        "text": "Коммерческая возможность",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetOfferListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения коммерческих возможностей
   */
  "GetOfferListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения коммерческих возможностей",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "offerFilterValidation": {
        "type": "OfferFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации по страницам
       */
      "offerPagingValidation": {
        "type": "OfferPaging.ValidationError",
        "text": "Ошибка пагинации по страницам",
      },
    },
  },
  /**
   * Запрос получения коммерческой возможности
   */
  "GetOfferRequest": {
    "kind": "class",
    "text": "Запрос получения коммерческой возможности",
    "fields": {
      /**
       * Идентификатор коммерческой возможности
       */
      "id": {
        "type": "string",
        "text": "Идентификатор коммерческой возможности",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения коммерческой возможности
   */
  "GetOfferResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения коммерческой возможности",
    "fields": {
      /**
       * Коммерческая возможность
       */
      "data": {
        "type": "Offer",
        "text": "Коммерческая возможность",
      },
    },
  },
  /**
   * Коммерческая возможность(КВ)
   */
  "Offer": {
    "kind": "class",
    "text": "Коммерческая возможность(КВ)",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Тип коммерческой возможности
       */
      "type": {
        "type": "Offer.Type",
        "text": "Тип коммерческой возможности",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН.
       * Идентификатор дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\nИдентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор компании",
      },
      /**
       * Идентификатор технологического плана
       */
      "planId": {
        "type": "int32",
        "text": "Идентификатор технологического плана",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Подключать ли автоматическую подписку
       */
      "isEnableAutoSubscribe": {
        "type": "bool",
        "text": "Подключать ли автоматическую подписку",
      },
      /**
       * Тип статуса заказа
       */
      "statusType": {
        "type": "Offer.StatusType",
        "text": "Тип статуса заказа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Цена
       */
      "price": {
        "type": "google.protobuf.DoubleValue",
        "text": "Цена",
      },
      /**
       * Признак принадлежности к цифровому пути
       */
      "isDigitalWay": {
        "type": "bool",
        "text": "Признак принадлежности к цифровому пути",
      },
      /**
       * Дата создания записи.
       * Заполняется сервером
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания записи.\nЗаполняется сервером",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Адрес размещения офферты.
       * Полный url до файла
       */
      "offerUrl": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес размещения офферты.\nПолный url до файла",
      },
      /**
       * Снапшот состояния технологического плана на момент создания предложения.
       * В данный момент это ссылка в базе на запись, в будущем это будет снапшот
       */
      "plan": {
        "type": "Plan",
        "text": "Снапшот состояния технологического плана на момент создания предложения.\nВ данный момент это ссылка в базе на запись, в будущем это будет снапшот",
      },
      /**
       * Цена по скидке
       */
      "discountPrice": {
        "type": "google.protobuf.DoubleValue",
        "text": "Цена по скидке",
      },
      /**
       * Условия на скидку.
       * Если условий много то для срабатывания должны выполнять все условия
       */
      "discountRequirementTypes": {
        "type": "Offer.DiscountRequirementType",
        "text": "Условия на скидку.\nЕсли условий много то для срабатывания должны выполнять все условия",
      },
    },
  },
  /**
   * Фильтр по коммерческим возможностям
   */
  "OfferFilter": {
    "kind": "class",
    "text": "Фильтр по коммерческим возможностям",
    "fields": {
      /**
       * По типам
       */
      "types": {
        "type": "Offer.Type",
        "text": "По типам",
      },
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
      /**
       * По идентификаторам компаний
       */
      "companyIds": {
        "type": "int32",
        "text": "По идентификаторам компаний",
      },
    },
  },
  /**
   * Ошибки валидации фильтра по коммерческим возможностям.
   * Эти проверки выполняются до обращения в базу данных
   */
  "OfferFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации фильтра по коммерческим возможностям.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Формат ОРПОН некорректен
       */
      "orpons": {
        "type": "OfferFilter.ValidationError.OrponsInvalid",
        "text": "Формат ОРПОН некорректен",
      },
      /**
       * Формат идентификатора компании некорректен
       */
      "companyIds": {
        "type": "OfferFilter.ValidationError.CompanyIdsInvalid",
        "text": "Формат идентификатора компании некорректен",
      },
    },
  },
  /**
   * Причины:
   * - Формат идентификатора компании некорректен;
   * - Идентификатора компании передан некорректно, к примеру, значение <= 1
   */
  "OfferFilter.ValidationError.CompanyIdsInvalid": {
    "kind": "class",
    "text": "Причины:\n- Формат идентификатора компании некорректен;\n- Идентификатора компании передан некорректно, к примеру, значение <= 1",
  },
  /**
   * - Формат ОРПОН некорректен;
   * - ОРПОН передан некорректно, к примеру, значение <= 1
   */
  "OfferFilter.ValidationError.OrponsInvalid": {
    "kind": "class",
    "text": "- Формат ОРПОН некорректен;\n- ОРПОН передан некорректно, к примеру, значение <= 1",
  },
  /**
   * Пагинация по коммерческим возможностям
   */
  "OfferPaging": {
    "kind": "class",
    "text": "Пагинация по коммерческим возможностям",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "OfferPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "OfferPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по коммерческим возможностям.
   * Эти проверки выполняются до обращения в базу данных
   */
  "OfferPaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по коммерческим возможностям.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "OfferPaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "OfferPaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "OfferPaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "OfferPaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Справочник условий на скидки
   */
  "Offer.DiscountRequirementType": {
    "kind": "enum",
    "text": "Справочник условий на скидки",
    "values": {
      /**
       * Значение не указано.
       * Если указана цена по скидке, а условие не проставлено, скидка не отображается и не применяется
       */
      "DISCOUNT_REQUIREMENT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано.\nЕсли указана цена по скидке, а условие не проставлено, скидка не отображается и не применяется",
      },
      /**
       * Безусловная скидка
       */
      "NO_CONDITIONS": {
        "i": 1,
        "text": "Безусловная скидка",
      },
      /**
       * ШПД интернет оплачен
       */
      "INTERNET_IS_PAID": {
        "i": 2,
        "text": "ШПД интернет оплачен",
      },
    },
  },
  /**
   * Типы статусов коммерческих возможностей
   */
  "Offer.StatusType": {
    "kind": "enum",
    "text": "Типы статусов коммерческих возможностей",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Активно.
       * Доступно
       */
      "ACTIVE": {
        "i": 1,
        "text": "Активно.\nДоступно",
      },
      /**
       * Заблокировано.
       * Приостановлено
       */
      "BLOCKED": {
        "i": 2,
        "text": "Заблокировано.\nПриостановлено",
      },
    },
  },
  /**
   * Типы коммерческих возможностей
   */
  "Offer.Type": {
    "kind": "enum",
    "text": "Типы коммерческих возможностей",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * УК.
       * Услуги, которые назначаются на управляющие компанию
       */
      "COMPANY": {
        "i": 1,
        "text": "УК.\nУслуги, которые назначаются на управляющие компанию",
      },
      /**
       * Ростелеком.
       * Услуги, которые Ростелеком подключает напрямую физическим лицам
       */
      "RTK": {
        "i": 2,
        "text": "Ростелеком.\nУслуги, которые Ростелеком подключает напрямую физическим лицам",
      },
      /**
       * Общая.
       * Услуги, которые видят клиенты обоих типов
       */
      "SHARED": {
        "i": 3,
        "text": "Общая.\nУслуги, которые видят клиенты обоих типов",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "OfferPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "OfferPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По цене
       */
      "PRICE": {
        "i": 2,
        "text": "По цене",
      },
    },
  },
}